import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:tenant_uuid/:insuree_uuid',
    name: 'PolicyView',
    component: () => import(/* webpackChunkName: "triglav_vortec_policy" */ '@/views/PolicyView.vue'),
    meta: {
      navigator: true,
    },
  },
  {
    path: '/:tenant_uuid/:insuree_uuid/faq',
    name: 'FAQView',
    component: () => import(/* webpackChunkName: "triglav_vortec_policy" */ '@/views/FAQView.vue'),
    meta: {
      navigator: true,
      authenticated: true,
    },
  },
  {
    path: '/:tenant_uuid/:insuree_uuid/contact',
    name: 'ContactView',
    component: () => import(/* webpackChunkName: "triglav_vortec_policy" */ '@/views/ContactView.vue'),
    meta: {
      navigator: true,
      authenticated: true,
    },
  },
  {
    path: '/:tenant_uuid/:insuree_uuid/menu',
    name: 'MenuView',
    component: () => import(/* webpackChunkName: "triglav_vortec_policy" */ '@/views/MenuView.vue'),
    meta: {
      navigator: true,
      authenticated: true,
    },
  },
  {
    path: '/:tenant_uuid/:insuree_uuid/activity',
    name: 'ActivityView',
    component: () => import(/* webpackChunkName: "triglav_vortec_policy" */ '@/views/ActivityView.vue'),
    meta: {
      navigator: true,
      authenticated: true,
    },
  },
  {
    path: '/:tenant_uuid/:insuree_uuid/verification',
    name: 'SocialIDAuthentication',
    component: () => import(/* webpackChunkName: "triglav_vortec" */ '@/views/auth/SocialIDAuthentication.vue'),
    meta: {
      authenticated: false,
    },
  },
  {
    path: '/:tenant_uuid/:insuree_uuid/verification/:socialID/email',
    name: 'EmailAuthentication',
    component: () => import(/* webpackChunkName: "triglav_vortec" */ '@/views/auth/EmailAuthentication.vue'),
    meta: {
      authenticated: false,
    },
  },
  {
    path: '/:tenant_uuid/:insuree_uuid/verification/:socialID',
    name: 'OTPAuthentication',
    component: () => import(/* webpackChunkName: "triglav_vortec" */ '@/views/auth/OTPAuthentication.vue'),
    meta: {
      authenticated: false,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "triglav_vortec" */ '@/views/NotFound.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
